import { VideoPath, Banner } from "../../components";
import { useEffect, useState } from "react";
import footer from "../../assets/images/footer.png";
import Timeline from "../../components/Timeline";
import MediaQuery from "react-responsive";
import "../../assets/less/learningPath.less";
import introduce from "../../assets/images/introduce.png";
import notintroduce from "../../assets/images/notintroduce.png";
import notreportDesign from "../../assets/images/not_reportDesign.png";
import reportDesign from "../../assets/images/reportDesign.png";
import group from "../../assets/images/group.png";
import notgroup from "../../assets/images/notgroup.png";
import parameter from "../../assets/images/parameter.png";
import notparameter from "../../assets/images/not_parameter.png";
import notpicture from "../../assets/images/not_picture.png";
import picture from "../../assets/images/picture.png";
import notfillFunction from "../../assets/images/not_fillFunction.png";
import fillFunction from "../../assets/images/fillFunction.png";
import notdesignerReport from "../../assets/images/not_designerReport.png";
import designerReport from "../../assets/images/designerReport.png";
import Feedback from "../../components/Feedback";
const Home = () => {
  const [title, setTitle] = useState("FineReport 基礎學習路徑");
  const [path] = useState("basiclearning");
  const [index, setindex] = useState(0);
  const [person] = useState("persons");
  const [alertMessage] = useState({
    message:
      "提示：點亮所有影片並完成自測題目，即可獲得帆軟給您頒發的「FineReport線上基礎課程結業證書」。學員可自由選擇章節學習，無須按照規定的路線，最後只要點亮所有課程即可獲取證書，快來解鎖影片吧！",
    alert: false,
  });
  const [bannerData] = useState({
    h1: "FineReport基礎學習路徑",
    p: "零基礎新手快速入門,學習加自測",
    br: "",
  });

  const [Homedata] = useState([
    {
      title: "第1章 產品簡介",
      description: "本章將教你如何安裝FineReport，並了解其功能。",
      imageView: introduce,
      imageNotView: notintroduce,
      id: index + 1,
      lid: 5,
      direction: "left",
    },
    {
      title: "第2章 報表設計	",
      description: "本章將教你開發不同格式的報表，並自訂樣式效果。",
      imageView: reportDesign,
      imageNotView: notreportDesign,
      id: index + 2,
      lid: 6,
      direction: "right",
    },
    {
      title: "第3章 報表分組分頁分欄	",
      description: "本章將教你設定報表分組、分頁、分欄，讓資料更直觀。",
      imageView: group,
      imageNotView: notgroup,
      id: index + 3,
      lid: 7,
      direction: "left",
    },
    {
      title: "第4章 參數介紹",
      description: "本章將教你報表參數的應用，實現資料過濾、下鑽等效果。",
      imageView: parameter,
      imageNotView: notparameter,
      id: index + 4,
      lid: 8,
      direction: "right",
    },
    {
      title: "第5章 圖表設計",
      description:
        "本章將教你透過五十多種圖表實現資料的視覺化展現，分析資料的變化趨勢或異常。",
      imageView: picture,
      imageNotView: notpicture,
      id: index + 5,
      lid: 9,
      direction: "left",
    },
    {
      title: "第6章 填報應用",
      description: "本章將教你如何實現資料的採集並寫入資料庫中。",
      imageView: fillFunction,
      imageNotView: notfillFunction,
      id: index + 6,
      lid: 10,
      direction: "right",
    },
    {
      title: "第7章 決策報表",
      description: "本章將教你透過組件的拖曳快速實現大屛的製作。",
      imageView: designerReport,
      imageNotView: notdesignerReport,
      id: index + 7,
      lid: 11,
      direction: "left",
    },
  ]);

  useEffect(() => {
    // This will run when the page first loads and whenever the title changes
    document.title = title;
  }, [title]);
  return (
    <>
     
      <Banner bannerData={bannerData} person={person} personNumber={896} />
      <VideoPath path={path} Homedata={Homedata} {...alertMessage} />
      {/* <MediaQuery maxWidth={1199}>
        <VideoPath />
      </MediaQuery>
      <MediaQuery minWidth={1200}>
        <Timeline />
      </MediaQuery> */}
      <Feedback />
      <footer>
        <img
          src={footer}
          alt="footer"
          style={{ width: "100%", background: "#f3f3f3" }}
        />
      </footer>
    </>
  );
};

export default Home;
